const timeZoneCityResourcePrefix = "TimeZoneCity_";
/** Convert an IANA time-zone id to its normal Planner localization resource key. */ export function getTimeZoneCityResourceKey(timeZone) {
    return `${timeZoneCityResourcePrefix}${timeZone.replace(/\//g, "__")}`;
}
/** Create a city resolver over the currently active Planner resource map. */ export function createTimeZoneCityResolver(resources, fallbackResources) {
    return (timeZone)=>{
        const resourceKey = getTimeZoneCityResourceKey(timeZone);
        const value = resources[resourceKey] ?? fallbackResources?.[resourceKey];
        return typeof value === "string" ? value : undefined;
    };
}
